import React, { useEffect, useState } from "react";

import EditAccountInfo from "./EditAccountInfo";

import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import {
  getName,
  updateOwnUserMeta,
  updatePassword,
} from "../../../../redux/reducers/user";

import {
  getErrorMessage,
  validate,
  ValType,
} from "../../../../utils/ValidationFunctions";
import { RequestState } from "../../../../utils/RequestState";

type Props = { handleClose: () => void };

const EditAccountInfoContainer: React.FC<Props> = ({ handleClose }) => {
  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();
  const display_name = useAppSelector(getName);

  const [name, setName] = useState<string>();
  const [curPass, setCurPass] = useState<string>("");
  const [newPass, setNewPass] = useState<string>("");
  const [confirmPass, setConfirmPass] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const handleName = (value: string) => {
    setName(value);

    if (value !== undefined) {
      setError(false);
      setRequestState(RequestState.Pending);
    } else {
      setError(true);
    }
  };

  const handleCurPass = (value: string) => {
    setCurPass(value);
  };

  const handleNewPass = (value: string) => {
    setNewPass(value);
  };

  const handleConfirmPass = (value: string) => {
    setConfirmPass(value);
  };

  useEffect(() => {
    if (errorMessage !== "") {
      setErrorMessage("");
    }

    if (curPass && newPass && confirmPass) {
      setRequestState(RequestState.Pending);
    }
  }, [curPass, newPass, confirmPass]);

  const handleUserInfoSubmit = async () => {
    if (auth_token) {
      if (error) {
        return;
      }

      if (newPass && curPass && confirmPass) {
        const validation = await validate(
          newPass,
          ValType.PasswordMatches,
          confirmPass
        );

        if (!validation) {
          setErrorMessage(getErrorMessage(ValType.PasswordMatches));
          setRequestState(RequestState.Pending);
          return;
        }
      }

      setRequestState(RequestState.Doing);

      if (newPass && curPass && confirmPass) {
        dispatch(
          updatePassword({
            auth_token: auth_token,
            current_password: curPass,
            new_password: newPass,
            confirm_password: confirmPass,
          })
        ).finally(() => {
          if (!name) {
            setRequestState(RequestState.Success);
          }
          setNewPass("");
          setCurPass("");
          setConfirmPass("");
        });
      }

      if (name) {
        dispatch(
          updateOwnUserMeta({
            auth_token: auth_token,
            update: { sonic_name: name },
          })
        ).finally(() => {
          setRequestState(RequestState.Success);
        });
      }
    }
  };

  return (
    <EditAccountInfo
      handleClose={handleClose}
      display_name={display_name}
      handleName={handleName}
      curPass={curPass}
      newPass={newPass}
      confirmPass={confirmPass}
      handleCurPass={handleCurPass}
      handleNewPass={handleNewPass}
      handleConfirmPass={handleConfirmPass}
      handleUserInfoSubmit={handleUserInfoSubmit}
      errorMessage={errorMessage}
      requestState={requestState}
    />
  );
};

export default EditAccountInfoContainer;
